import { isAxiosError, isCancel } from 'axios';

/**
 * True when a request was aborted/canceled (unmount, navigation, AbortController).
 * These are not application failures and should not be logged as console errors
 * (Datadog RUM treats console.error as handled errors).
 */
export function isCanceledRequestError(error: unknown): boolean {
  if (isCancel(error)) {
    return true;
  }

  if (isAxiosError(error) && error.code === 'ERR_CANCELED') {
    return true;
  }

  // DOMException / CanceledError are not always `instanceof Error` (jsdom / some runtimes).
  if (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error.name === 'AbortError' || error.name === 'CanceledError')
  ) {
    return true;
  }

  return false;
}
